/* Import main CSS modules */
import '../css/critical.scss'
import '../css/main.scss'

/* Import JS modules */
import MainMenu from './MainMenu';
import SearchForm from './SearchForm';
import Carousels from './Carousels';
import Categories from './Categories';
import ContactFormAnalytics from './ContactFormAnalytics';
import LoadMore from './LoadMore';

(function() {
	MainMenu.init();
	SearchForm.init();
	Carousels.init();
	Categories.init();
	ContactFormAnalytics.init();
	LoadMore.init();
})();
